import Http from "../../services/http";
import {
  CLEAR_CONFIG_SUCCESS,
  IMPORT_APIDAE_DATA_SUCCESS,
  GET_ACCOMODATION_OPTIONS_SUCCESS,
  GET_ACCOMODATION_IMAGES_SUCCESS,
  GET_ACCOMODATION_ROOMS_SUCCESS,
  GET_ACCOMODATION_MEALPLANS_SUCCESS,
  CHANGE_LANG_SUCCESS,
} from "../../actions";
import {
  snackbar,
  asyncIndicatorShow,
  asyncIndicatorHide,
} from "../../app/actions";
import { getString } from "../../utils";

export const clearConfigSuccess = () => ({
  type: CLEAR_CONFIG_SUCCESS,
});

export const clearConfig = () => (dispatch) => {
  dispatch(clearConfigSuccess());
};

export const loadConfig = (code, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/hebergement/${lang}`)
    .then((result) => {
      dispatch(importExistingDataSuccess(result.config));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const importExistingDataSuccess = (config) => ({
  type: IMPORT_APIDAE_DATA_SUCCESS,
  config,
});

export const importExistingData =
  (code, lang, apidae, othyssia, ospita, isMaeva = false) =>
  (dispatch) => {
    dispatch(asyncIndicatorShow());
    const body = {
      apidae: getString(apidae),
      othyssia: getString(othyssia),
      ospita: isMaeva ? getString(ospita) : "",
    };
    return Http.post(
      `/merchants/${code}/hebergement/importExistingData/${lang}`,
      body
    )
      .then((result) => {
        dispatch(importExistingDataSuccess(result.config));
        dispatch(asyncIndicatorHide());
        return result;
      })
      .catch((err) => {
        console.log(err);
        dispatch(asyncIndicatorHide());
      });
  };

export const changeLangSuccess = (lang) => ({
  type: CHANGE_LANG_SUCCESS,
  lang,
});

export const changeLang = (code, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/hebergement/${lang}`)
    .then((result) => {
      dispatch(changeLangSuccess(lang));
      dispatch(importExistingDataSuccess(result.config));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const getAccomodationOptionsSuccess = (accomodationOptions) => ({
  type: GET_ACCOMODATION_OPTIONS_SUCCESS,
  accomodationOptions,
});

export const addOption = (merchantCode, optionCode) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/addOption/${optionCode}`)
    .then((result) => {
      dispatch(snackbar("L'option a été ajoutée"));
      dispatch(getAccomodationOptionsSuccess(result.options));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("L'option n'a pas pu être ajoutée"));
      dispatch(asyncIndicatorHide());
    });
};

export const deleteOption = (merchantCode, optionCode) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/deleteOption/${optionCode}`)
    .then((result) => {
      dispatch(snackbar("L'option a été supprimée"));
      dispatch(getAccomodationOptionsSuccess(result.options));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("L'option n'a pas pu être supprimée"));
      dispatch(asyncIndicatorHide());
    });
};

export const togglePaidOption = (merchantCode, optionCode) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/togglePaidOption/${optionCode}`)
    .then((result) => {
      dispatch(snackbar("L'option a été mise à jour"));
      dispatch(getAccomodationOptionsSuccess(result.options));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("L'option n'a pas été mise à jour"));
      dispatch(asyncIndicatorHide());
    });
};

export const getAccomodationImagesSuccess = (images) => ({
  type: GET_ACCOMODATION_IMAGES_SUCCESS,
  images,
});

export const deleteImage = (merchantCode, imageCode, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/deleteImage/${imageCode}/${lang}`)
    .then((result) => {
      dispatch(snackbar("L'image a été supprimée"));
      dispatch(getAccomodationImagesSuccess(result.images));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("L'image n'a pas pu être supprimée"));
      dispatch(asyncIndicatorHide());
    });
};

export const getImages = (merchantCode, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/getImages/${lang}`)
    .then((result) => {
      dispatch(getAccomodationImagesSuccess(result.images));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const updateGlobalConfig = (code, values, lang) => (dispatch) => {
  const {
    name,
    slug,
    kind,
    meuble_kind,
    source,
    apidae,
    ospita,
    othyssia,
    chalet_moniteur,
    all_inclusive,
    email,
    phone,
    ranking_id,
    address1,
    address2,
    cp,
    city,
    max_capacity,
    double_beds,
    single_beds,
    bunk_beds,
    couches,
    nb_rooms,
    nb_bedrooms,
    nb_bathrooms,
    nb_restrooms,
    floor_nb,
    surface,
  } = values;
  const body = {
    name: name,
    slug: getString(slug),
    kind: kind,
    meuble_kind: kind === "MEUBLE" ? getString(meuble_kind) : undefined,
    source: getString(source),
    apidae: getString(apidae),
    ospita: getString(ospita),
    othyssia: getString(othyssia),
    chalet_moniteur: chalet_moniteur === true || chalet_moniteur === 1 ? 1 : 0,
    all_inclusive: all_inclusive === true || all_inclusive === 1 ? 1 : 0,
    email: getString(email),
    phone: getString(phone),
    ranking: ranking_id,
    address1: getString(address1),
    address2: getString(address2),
    cp: getString(cp),
    city: getString(city),
    max_capacity: getString(max_capacity),
    double_beds: getString(double_beds),
    single_beds: getString(single_beds),
    bunk_beds: getString(bunk_beds),
    couches: couches === true || couches === 1 ? 1 : 0,
    nb_rooms: getString(nb_rooms),
    nb_bedrooms: getString(nb_bedrooms),
    nb_bathrooms: getString(nb_bathrooms),
    nb_restrooms: getString(nb_restrooms),
    floor_nb: getString(floor_nb),
    surface: getString(surface),
  };
  dispatch(asyncIndicatorShow());
  return Http.post(
    `/merchants/${code}/hebergement/updateGlobalConfig/${lang}`,
    body
  )
    .then((result) => {
      dispatch(snackbar("La configuration a été mise à jour"));
      dispatch(importExistingDataSuccess(result.config));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("La configuration n'a pas pu être mise à jour"));
      dispatch(asyncIndicatorHide());
    });
};

export const deleteConfig = (merchantCode) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/hebergement/deleteAccomodation`)
    .then((result) => {
      dispatch(snackbar("La configuration hébergement a été supprimée"));
      dispatch(asyncIndicatorHide());
      window.location.href = `/configuration/marchands/${merchantCode}/hebergement`;
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(
        snackbar(
          "Erreur lors de la suppression de la configuration hébergement"
        )
      );
      dispatch(asyncIndicatorHide());
    });
};

export const updateAgeLimits = (merchantCode, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.post(
    `/merchants/${merchantCode}/hebergement/updateAgeLimits/${lang}`
  )
    .then((result) => {
      dispatch(snackbar("Les limites d'âges ont été mises à jour"));
      dispatch(importExistingDataSuccess(result.config));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("Erreur lors de la mise à jour des limites d'âges"));
      dispatch(asyncIndicatorHide());
    });
};

export const updateSpecificConfig = (code, values, lang) => (dispatch) => {
  const {
    subkind,
    short_desc_winter,
    long_desc_winter,
    short_desc_summer,
    long_desc_summer,
  } = values;
  const body = {
    subkind: getString(subkind),
    short_desc_winter: getString(short_desc_winter),
    long_desc_winter: getString(long_desc_winter),
    short_desc_summer: getString(short_desc_summer),
    long_desc_summer: getString(long_desc_summer),
  };
  dispatch(asyncIndicatorShow());
  return Http.post(
    `/merchants/${code}/hebergement/updateSpecificConfig/${lang}`,
    body
  )
    .then((result) => {
      dispatch(snackbar("La configuration a été mise à jour"));
      dispatch(importExistingDataSuccess(result.config));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("La configuration n'a pas pu être mise à jour"));
      dispatch(asyncIndicatorHide());
    });
};

export const updateLatLng = (merchantCode, lat, lng) => (dispatch) => {
  const body = {
    lat,
    lng,
  };
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/${merchantCode}/hebergement/updateLatLng`, body)
    .then((result) => {
      dispatch(snackbar("La géolocalisation a été sauvegardée"));
      dispatch(asyncIndicatorHide());
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("La géolocalisation n'a pas pu être sauvegardée"));
      dispatch(asyncIndicatorHide());
    });
};

export const getAccomodationRoomsSuccess = (rooms) => ({
  type: GET_ACCOMODATION_ROOMS_SUCCESS,
  rooms,
});

export const updateRoom =
  (merchantCode, roomId, libelle, capacity, description, lang) =>
  (dispatch) => {
    const body = {
      libelle,
      capacity,
      description,
    };
    dispatch(asyncIndicatorShow());
    return Http.post(
      `/merchants/${merchantCode}/hebergement/updateRoom/${roomId}/${lang}`,
      body
    )
      .then((result) => {
        dispatch(snackbar("La chambre a été mise à jour"));
        dispatch(getAccomodationRoomsSuccess(result.rooms));
        dispatch(asyncIndicatorHide());
      })
      .catch((err) => {
        console.log(err);
        dispatch(snackbar("La chambre n' pas pu être mise à jour"));
        dispatch(asyncIndicatorHide());
      });
  };

export const getAccomodationMealplansSuccess = (mealplans) => ({
  type: GET_ACCOMODATION_MEALPLANS_SUCCESS,
  mealplans,
});

export const updateMealplan =
  (merchantCode, mealplanCode, description, lang) => (dispatch) => {
    const body = {
      description,
    };
    dispatch(asyncIndicatorShow());
    return Http.post(
      `/merchants/${merchantCode}/hebergement/updateMealplan/${mealplanCode}/${lang}`,
      body
    )
      .then((result) => {
        dispatch(snackbar("Le plan-repas a été mis à jour"));
        dispatch(getAccomodationMealplansSuccess(result.mealplans));
        dispatch(asyncIndicatorHide());
      })
      .catch((err) => {
        console.log(err);
        dispatch(snackbar("Le plan-repas n'a pas pu être mis à jour"));
        dispatch(asyncIndicatorHide());
      });
  };

export const updateImage =
  (merchantCode, imageId, title, altText, facet, lang) => (dispatch) => {
    const body = {
      title,
      altText,
      facet,
    };
    dispatch(asyncIndicatorShow());
    return Http.post(
      `/merchants/${merchantCode}/hebergement/updateImage/${imageId}/${lang}`,
      body
    )
      .then((result) => {
        dispatch(snackbar("L'image a été mise à jour"));
        dispatch(getAccomodationImagesSuccess(result.images));
        dispatch(asyncIndicatorHide());
      })
      .catch((err) => {
        console.log(err);
        dispatch(snackbar("L'image n'a pas pu être mise à jour"));
        dispatch(asyncIndicatorHide());
      });
  };

export const getAccomodationRooms = (merchantCode, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/hebergement/getRooms/${lang}`)
    .then((result) => {
      dispatch(getAccomodationRoomsSuccess(result.rooms));
      dispatch(asyncIndicatorHide());
    })
    .catch((err) => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const reorderOptions = (merchantCode, options) => (dispatch) => {
  const body = {
    options,
  };
  dispatch(asyncIndicatorShow());
  return Http.post(
    `/merchants/${merchantCode}/hebergement/reorderOptions`,
    body
  )
    .then((result) => {
      dispatch(snackbar("Les options ont été réordonnées"));
      dispatch(getAccomodationOptionsSuccess(result.accomodationOptions));
      dispatch(asyncIndicatorHide());
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("Les options n'ont pas pu être réordonnées"));
      dispatch(asyncIndicatorHide());
    });
};

export const reorderImages = (merchantCode, images, lang) => (dispatch) => {
  const body = {
    images,
  };
  dispatch(asyncIndicatorShow());
  return Http.post(
    `/merchants/${merchantCode}/hebergement/reorderImages/${lang}`,
    body
  )
    .then((result) => {
      dispatch(snackbar("Les images ont été réordonnées"));
      dispatch(getAccomodationImagesSuccess(result.images));
      dispatch(asyncIndicatorHide());
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("Les images n'ont pas pu être réordonnées"));
      dispatch(asyncIndicatorHide());
    });
};

export const reorderRoomImages =
  (merchantCode, roomId, images, lang) => (dispatch) => {
    const body = {
      images,
    };
    dispatch(asyncIndicatorShow());
    return Http.post(
      `/merchants/${merchantCode}/hebergement/reorderRoomImages/${roomId}/${lang}`,
      body
    )
      .then((result) => {
        dispatch(snackbar("Les images ont été réordonnées"));
        dispatch(getAccomodationRoomsSuccess(result.rooms));
        dispatch(asyncIndicatorHide());
      })
      .catch((err) => {
        console.log(err);
        dispatch(snackbar("Les images n'ont pas pu être réordonnées"));
        dispatch(asyncIndicatorHide());
      });
  };

export const deleteRoomImage =
  (merchantCode, roomId, imageCode, lang) => (dispatch) => {
    dispatch(asyncIndicatorShow());
    return Http.get(
      `/merchants/${merchantCode}/hebergement/deleteRoomImage/${roomId}/${imageCode}/${lang}`
    )
      .then((result) => {
        dispatch(snackbar("L'image a été supprimée"));
        dispatch(getAccomodationRoomsSuccess(result.rooms));
        dispatch(asyncIndicatorHide());
        return result;
      })
      .catch((err) => {
        console.log(err);
        dispatch(snackbar("L'image n'a pas pu être supprimée"));
        dispatch(asyncIndicatorHide());
      });
  };

export const importAccomodationRooms =
  (merchantCode, lang, othyssia) => (dispatch) => {
    dispatch(asyncIndicatorShow());
    return Http.get(
      `/merchants/${merchantCode}/hebergement/importRooms/${othyssia}/${lang}`
    )
      .then((result) => {
        dispatch(getAccomodationRoomsSuccess(result.rooms));
        dispatch(asyncIndicatorHide());
        return result;
      })
      .catch((err) => {
        console.log(err);
        dispatch(asyncIndicatorHide());
      });
  };

export const deleteAccomodationRooms = (merchantCode, lang) => (dispatch) => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${merchantCode}/hebergement/deleteRooms/${lang}`)
    .then((result) => {
      dispatch(snackbar("Les chambres ont été supprimées"));
      dispatch(getAccomodationRoomsSuccess(result.rooms));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch((err) => {
      console.log(err);
      dispatch(snackbar("Erreur lors de la suppression des chambres"));
      dispatch(asyncIndicatorHide());
    });
};



// WEBPACK FOOTER //
// ./src/merchant/accomodation/actions.js